var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M18.215 3.162c8.077 0 14.625 6.547 14.625 14.625s-6.548 14.625-14.625 14.625S3.59 25.864 3.59 17.787 10.137 3.162 18.215 3.162"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.395 8.434v21.611a1.81 1.81 0 0 1-1.817 1.818H9.814a1.81 1.81 0 0 1-1.818-1.818V8.434a1.81 1.81 0 0 1 1.818-1.818h16.748a1.81 1.81 0 0 1 1.818 1.818z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M28.397 8.434v21.611a1.81 1.81 0 0 1-1.818 1.818h-8.374V6.616h8.374a1.81 1.81 0 0 1 1.818 1.818"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M27.347 27.498a.92.92 0 0 1-.917.916H11.391a.92.92 0 0 1-.916-.916c0-.513.404-.917.916-.917h15.055c.497 0 .917.404.917.917z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M27.358 27.5a.92.92 0 0 1-.917.916h-8.25V26.6h8.25c.497 0 .917.404.917.916z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M24.923 23.613a.92.92 0 0 1-.916.917H11.39a.92.92 0 0 1-.916-.917c0-.513.404-.917.916-.917h12.616c.497 0 .916.404.916.917"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M24.934 23.615a.92.92 0 0 1-.917.917h-5.826v-1.818h5.826c.498 0 .917.404.917.917z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M24.923 19.728a.92.92 0 0 1-.916.917H11.39a.92.92 0 0 1-.916-.917c0-.513.404-.917.916-.917h12.616c.497 0 .916.404.916.917"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M24.934 19.73a.92.92 0 0 1-.917.917h-5.826v-1.818h5.826c.498 0 .917.404.917.917z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M14.795 13.484h-.544v-.544a.92.92 0 0 0-.917-.917.91.91 0 0 0-.916.917v.544h-.544a.92.92 0 0 0-.917.916c0 .513.404.917.917.917h.543v.544c0 .497.404.917.917.917a.91.91 0 0 0 .917-.917v-.544h.543a.92.92 0 0 0 .917-.917.91.91 0 0 0-.917-.916"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "M24.442 14.357c0 .513-.404.948-.917.948H18.18c-.497 0-.916-.42-.916-.948s.404-.948.916-.948h5.345c.497 0 .917.42.917.948"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M24.453 14.354c0 .513-.404.948-.917.948H18.19v-1.88h5.345c.497 0 .917.42.917.948z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M26.555 5.706H9.807A2.74 2.74 0 0 0 7.072 8.44v21.612a2.74 2.74 0 0 0 2.735 2.734h16.748a2.74 2.74 0 0 0 2.734-2.735V8.426a2.74 2.74 0 0 0-2.734-2.735zm.916 24.33a.92.92 0 0 1-.916.917H9.807a.92.92 0 0 1-.917-.917V8.425c0-.497.404-.917.917-.917h16.748c.497 0 .916.404.916.917z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M29.3 8.425v21.61a2.74 2.74 0 0 1-2.735 2.735h-8.374v-1.817h8.375a.92.92 0 0 0 .916-.917V8.425a.92.92 0 0 0-.916-.917H18.19V5.69h8.375A2.74 2.74 0 0 1 29.3 8.425"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M23.463 5.045v3.092a1.81 1.81 0 0 1-1.818 1.817h-6.913a1.81 1.81 0 0 1-1.818-1.817V5.045a1.81 1.81 0 0 1 1.818-1.818h6.913a1.81 1.81 0 0 1 1.818 1.818"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M23.474 5.048v3.091a1.81 1.81 0 0 1-1.818 1.818h-3.465V3.214h3.465a1.81 1.81 0 0 1 1.818 1.818z"
  })));
};
export default SvgDocument;